import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-339a8b1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "main",
  class: "grid-container"
}
const _hoisted_2 = { class: "grid-item" }
const _hoisted_3 = { class: "grid-item" }
const _hoisted_4 = { class: "grid-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavTop = _resolveComponent("NavTop")!
  const _component_NavSide = _resolveComponent("NavSide")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_record = _resolveComponent("record")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(_component_NavTop)
    ]),
    _createElementVNode("aside", _hoisted_3, [
      _createVNode(_component_NavSide)
    ]),
    _createElementVNode("main", _hoisted_4, [
      _createVNode(_component_router_view)
    ]),
    (_ctx.showNewAppointmentModal)
      ? (_openBlock(), _createBlock(_component_record, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}